export default __webpack_public_path__ + "static/image5-77a3d2fe98fd76c866539b1de7b6e805.jpg";